import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabPanelComponent } from './tab-panel/tab-panel.component';
import {InsparkComponentsModule} from '@inspark/inspark-components';
import {TranslateModule} from '@ngx-translate/core';



@NgModule({
  declarations: [TabPanelComponent],
  imports: [
    CommonModule,
    TranslateModule,
    InsparkComponentsModule
  ],
  exports: [TabPanelComponent]
})
export class InsparkTabPanelModule { }
